import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { UpaUserProfileDataModel, Validation } from '../../../Core/models';
import { PostalCodeValidationService, SwProcessStateService } from '../../../Core/Services';
import { debounceTime } from 'rxjs/operators';
import { CssClass } from '../../../Core/constants';

@Component({
  selector: '[app-postal-code]',
  templateUrl: './postal-code.component.html',
  styleUrls: ['./postal-code.component.css']
})
export class PostalCodeComponent implements OnInit {

  constructor(private postalCodeValidationService: PostalCodeValidationService, private swProcessStateService: SwProcessStateService) { }
  @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();

  public errorClass = '';
  public error: Validation = new Validation();
  public flag: number;
  public postalCode: string;
  @Input() isUpaEnable: boolean = false;
  @Input() isUserLoggedIn: boolean = false;
  @Input() upaUserData: UpaUserProfileDataModel;

  ngOnInit() {
    this.postalCodeValidationService.postalCodeValid$.subscribe({
      next: (error) => {
        this.error.isInValid = error.isInValid;
        this.error.errorCss = error.errorCss
      }
    })
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (isSw) {
        this.swPostalCode();
      }
    })
  }

  ngOnChanges() {
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (this.isUpaEnable && this.isUserLoggedIn && !isSw) {
        this.postalCode = this.upaUserData?.province?.toString();
        this.submitAnswer(this.postalCode);
      } else if (this.isUpaEnable && !this.isUserLoggedIn && !isSw) {
        this.postalCode = "";
        this.submitAnswer(this.postalCode);
      }
    })
  }
  swPostalCode() {
    this.swProcessStateService.swProcessModel$.subscribe(swInput => {
      this.postalCode = swInput?.postalCode;
      this.submitAnswer(this.postalCode)
    })
  }

  submitAnswer(postalCode: string) {
    console.log(postalCode, this.postalCode)
      this.onSubmit.emit(postalCode)
    
  }

}
